import { makeStyles } from '@material-ui/styles';
import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { Wallet } from '@/api/wallets/types';
import { ReactComponent as RoubleIcon } from '@/assets/icons/rouble.svg';
import { Label, MoneyAmountValue, OptionSelection, Space } from '@/components';

const useStyles = makeStyles(() => ({
  money: {
    fontWeight: 500,
    alignItems: 'flex-start',
  },
  currency: {
    fontSize: '10px',
  },
}));

interface SingleWalletOptionProps extends Wallet {
  disabled?: boolean;
  error?: ReactNode;
  onSelect?: () => void | Promise<void>;
  // FIXME: no main flag in api, stub here
  main?: boolean;
}

const SingleWalletOption: React.FC<SingleWalletOptionProps> = ({
  balance,
  main = false,
  id,
  disabled,
  error,
  onSelect,
}) => {
  const classes = useStyles();
  return (
    <OptionSelection
      startIcon={<RoubleIcon />}
      disabled={disabled}
      label={
        <Space>
          <FormattedMessage
            id={main ? 'withdrawal.fields.wallet.main.label' : 'withdrawal.fields.wallet.additional.label'}
          />
          <Label className="ym-hide-content">
            &nbsp;
            <FormattedMessage id="withdrawal.fields.wallet.code.label" values={{ id }} />
          </Label>
        </Space>
      }
      title={
        <MoneyAmountValue
          className={classes.money}
          currencyClassName={classes.currency}
          value={balance.amount}
          withCurrency
        />
      }
      error={error}
      onSelect={onSelect}
    />
  );
};

export default SingleWalletOption;
